import React, { FC } from 'react';
import styled, { css } from 'styled-components';

export interface PillButtonGroupProps {
  children: any;
}

const StyledPillButtonGroup = styled.div`
  ${({ theme: { space, media } }) => css`
    display: grid;
    gap: ${space.sm};
    grid-template-columns: repeat(2, 1fr);

    // Tablet > styles

    @media (min-width: ${media.md}) {
      display: flex;
    }
  `};
`;

export const PillButtonGroup: FC<React.PropsWithChildren<PillButtonGroupProps>> = ({ children, ...rest }) => (
  <StyledPillButtonGroup {...rest}>{children}</StyledPillButtonGroup>
);
